import { layout } from '@prisjakt/ui-base';

export const PAGE_CONTENT_GUTTER_BREAKPOINT = `${1200 - 1}px`;
export const OUTSIDE_AD_MIN_WIDTH = '200px';
export const OUTSIDE_AD_MAX_WIDTH = '300px';
export const SIDEBAR_CONTENT_WIDTH = layout.sidebarContentWidth.desktop.value;
export const SIDEBAR_MENU_WIDTH = layout.sidebarMenuWidth.desktop.value;
